// extracted by mini-css-extract-plugin
export var copyableField = "_km-4";
export var customerBadge = "_km-0";
export var customerInfoTitle = "_km-2";
export var details = "_km-1";
export var dropdownContainer = "_km-5";
export var dropdownImage = "_km-6";
export var editAssigneeForm = "_km-a";
export var editButton = "_km-3";
export var email = "_km-7";
export var hidden = "_km-d";
export var input = "_km-8";
export var saveButton = "_km-b";
export var shopifyIcon = "_km-c";
export var suggestionBadge = "_km-e";
export var suggestionText = "_km-f";
export var username = "_km-9";